import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/ui/text/Text';
import { TABLE_PALETTE } from '@/components/ui/tables/Table.constants';
import type { AsyncJob } from '@/api/domains/asyncJob/types';


// ── Types ──────────────────────────────────────────────────────────────────

export interface AsyncJobExpandedRowProps {
  row: AsyncJob;
}

// ── Component ──────────────────────────────────────────────────────────────

export const AsyncJobExpandedRow: React.FC<AsyncJobExpandedRowProps> = ({ row }) => {
  const { t: translate } = useTranslation('asyncJob');

  return (
    <div
      className="py-3 grid grid-cols-[auto_1fr] gap-x-8 gap-y-2 items-start"
      data-testid="async-job-expanded-row"
    >

      {/* Mensaje de error */}
      <Text variant="small-medium" color={TABLE_PALETTE.headerText} className="whitespace-nowrap font-bold">
        {translate('expanded.errorMessage')}:
      </Text>
      <Text variant="small-medium" color={TABLE_PALETTE.rowText} className="whitespace-pre-line">
        {row.errorMessage ?? '-'}
      </Text>

      {/* Email notificado */}
      <Text variant="small-medium" color={TABLE_PALETTE.headerText} className="whitespace-nowrap font-bold">
        {translate('expanded.requesterEmail')}:
      </Text>
      <Text variant="small-medium" color={TABLE_PALETTE.rowText}>
        {row.requesterEmail ?? '-'}
      </Text>

      {/* Fecha inicio */}
      <Text variant="small-medium" color={TABLE_PALETTE.headerText} className="whitespace-nowrap font-bold">
        {translate('expanded.startedAt')}:
      </Text>
      <Text variant="small-medium" color={TABLE_PALETTE.rowText}>
        {row.startedAt ?? '-'}
      </Text>

      {/* Fecha fin */}
      <Text variant="small-medium" color={TABLE_PALETTE.headerText} className="whitespace-nowrap font-bold">
        {translate('expanded.completedAt')}:
      </Text>
      <Text variant="small-medium" color={TABLE_PALETTE.rowText}>
        {row.completedAt ?? '-'}
      </Text>

      {/* Intentos fallidos */}
      <Text variant="small-medium" color={TABLE_PALETTE.headerText} className="whitespace-nowrap font-bold">
        {translate('expanded.failedAttempts')}:
      </Text>
      <Text variant="small-medium" color={TABLE_PALETTE.rowText}>
        {String(row.failedAttempts)}
      </Text>

      {/* Nombre del archivo */}
      <Text variant="small-medium" color={TABLE_PALETTE.headerText} className="whitespace-nowrap font-bold">
        {translate('expanded.fileName')}:
      </Text>
      <Text variant="small-medium" color={TABLE_PALETTE.rowText}>
        {row.fileName ?? '-'}
      </Text>

    </div>
  );
};
